import React, { useState, useRef } from 'react';
// import Image from 'rc-image';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import VideoPlayer from '../VideoPlayer/index';
import MockVideoPlayer from '../VideoPlayer/MockVideoPlayer';
// import Img404 from '@/assets/images/404.jpg';
// import ImgLoading from '../../assets/imgs/image-loading.png';
// import PCGameDefault from '../../assets/imgs/460215.png';
// import PCGameDefault from '@/pages/home/assets/img/common/pcgame-default.png';
import VisiabledImg from './components/VisiabledImg';
import './index.less';
import GameImage from '@/pages/home/components/GameImage';

// Carousel参数信息
interface paramsInfo {
  // 是否展示左右箭头
  showArrows?: boolean;
  // 是否展示指示器
  showIndicators?: boolean;
  // 是否循环
  infiniteLoop?: boolean;
  // 是否自动播放
  autoPlay?: boolean;
  // 是否拖拽滑动
  emulateTouch?: boolean;
  // 是否展示右上角状态
  showStatus?: boolean;
  // 鼠标放上去是否停止播放
  stopOnHover?: boolean;
  // 是否展示轮播缩放展示图
  showThumbs?: boolean;
  // 是否使用键盘左右按钮滑动
  useKeyboardArrows?: boolean;
  // 是否刷新
  swipeable?: boolean;
  // 动态高度
  dynamicHeight?: boolean;
}

interface VideoData {
  url: string; // 资源链接
  poster: string; // video封面
  isIframe: boolean; // 是否为iframe内嵌方式
}

// props信息
interface propsInfo {
  urlList: any[];
  videos?: VideoData[]; // 视频资源列表
  width?: string | number;
  height?: string | number;
  params: paramsInfo;
  noDataTip: React.ReactNode;
  videoScreen?: string[];
}

export default (props: propsInfo) => {
  const { urlList, videos = [], width, height, params, noDataTip, videoScreen = [] } = props;

  // console.log('propsprops', props);

  const {
    showArrows,
    showIndicators,
    infiniteLoop,
    autoPlay,
    emulateTouch,
    showStatus,
    stopOnHover,
    showThumbs,
    useKeyboardArrows,
    // swipeable,
    dynamicHeight,
  } = params || {};

  // 视频播放器组件实例数组，可以通过该组件实例 暂停、播放、获取player实例
  const videoPlayerRefs = useRef<any[]>([]);
  // 当前active轮播项索引
  const [activeSwiperIdx, setActiveSwiperIdx] = useState(0);
  // iframe加载状态集合
  // const [iframeLoadedStates, setIFrameLoadedStates] = useState<any>({});

  const [errorImgIndex, setErrorImgIndex] = useState();
  const [errorRandom, setErrorRandom] = useState();

  /**
   * 格式化宽度或者高度
   * @param val {string | number} 需要转换的值
   * @returns
   */
  const formatter = (val: string | number | undefined) => {
    if (!val) return val;
    val = val.toString();
    if (val.match('px')) return `${val}`;
    return `${val}px`;
  };

  const getKeyWithFlag = (flag: string, index: number): string => `${flag}-${index}`;

  const renderImageThumbs = (children: React.ReactChild[]): React.ReactChild[] => {
    if (!Array.isArray(children)) return [];
    return children.map((item: any, index: number): React.ReactElement => {
      const { key } = item;
      const { src = '' } = item?.props?.children?.props || {};
      let _url = src;
      if (errorImgIndex === index) {
        _url = `${src}?${errorRandom}`;
      }

      return <GameImage key={key} src={_url} entityType={'swipe'} />;
    });
  };

  const renderVideoThumb = (children: React.ReactChild[]): React.ReactChild[] => {
    if (!Array.isArray(children)) return [];
    return children.map((item: any, idx: number): React.ReactElement => {
      const { key, props } = item;
      return (
        <>
          <GameImage
            key={key}
            src={videoScreen?.length >= idx ? videoScreen[idx] : ''}
            entityType={'swipe'}
          />
          <span className="icon-play"></span>
        </>
      );
    });
  };

  const renderThumbs = (children: any) => {
    // 有图片链接，取 children[0] 位置渲染的图片列表，无则不考虑
    const imageThumbs = renderImageThumbs(urlList?.length ? children[0] : []);
    // 有图片链接时，视频渲染位置在 children[1]，否则视频会在 children[0]
    const videoThumbs = renderVideoThumb(urlList?.length ? children[1] : children[0]);
    return [...imageThumbs, ...videoThumbs];
  };

  const renderVideo = (data: any, idx: number) => {
    if (!data) return null;
    const { poster, isIframe, url } = data;
    const _poster = videoScreen[idx];
    return (
      <div
        key={getKeyWithFlag('video', idx)}
        type="video"
        src={poster}
        isIframe={isIframe}
        className="intelligence-swiper-video-wrapper"
      >
        <VideoPlayer
          ref={(el: any) => {
            videoPlayerRefs.current[idx] = el;
          }}
          posters={[_poster]}
          sources={[{ src: url }]}
        />
      </div>
    );
  };

  const renderMockPlayer = (data: any, idx: number): React.ReactChild => {
    const { url } = data || {};
    const poster = videoScreen[idx];
    return (
      <div
        key={getKeyWithFlag('mock-video-player', idx)}
        className="intelligence-swiper-video-wrapper"
      >
        <MockVideoPlayer poster={poster} source={{ src: url }} />
      </div>
    );
  };

  // 可视区域渲染video
  const renderVideoOrIframe = (data: any, idx: number) => {
    if (!data) return null;
    const { isIframe = false } = data;
    // if (isIframe) return renderIframe(data, idx);
    if (isIframe) return renderMockPlayer(data, idx);
    return renderVideo(data, idx);
  };

  // 轮播切换不是 视频 或 是另一个视频时，暂停 当前播放的视频
  const handleSwiperChange = (index: number, data: any): void => {
    const imageTotal = urlList?.length || 0;
    const videoTotal = videos?.length || 0;
    const total = imageTotal + videoTotal;
    let newIndex = index;
    // 切换到第一个 或者 最后一个时
    if (index === total) {
      // activeSwiperIdx === 0 说明是 切换到 最后一个，新的索引为 total - 1， 否则是 切换到 第一个 新的索引 为 0
      newIndex = activeSwiperIdx === 0 ? total - 1 : 0;
    }
    setActiveSwiperIdx(newIndex);
    if (index === undefined || index === null || !data) return;
    if (!videoPlayerRefs.current?.length) return;
    const { props } = data || {};
    const { type } = props || {};
    if (type !== 'video' || index !== activeSwiperIdx) {
      videoPlayerRefs.current.forEach((player: any) => {
        player.pause();
      });
    }
  };

  const getImgIndex = (flag: any, random: any) => {
    setErrorImgIndex(flag);
    setErrorRandom(random);
  };
  // console.log('urlList', urlList);
  // console.log('videos', videos);

  // 将轮播图内容过滤掉空值，避免 Carousel 将控制也同样处理为轮播元素
  const swiperContentList = [
    // 图片
    urlList?.length > 0 &&
      urlList?.map((url: string, idx: number) => (
        <div key={url + idx} style={{ height: '100%' }} className="every-img">
          <VisiabledImg src={url} getImgIndex={getImgIndex} flag={idx} />
        </div>
      )),

    // 视频
    videos?.length > 0 &&
      videos?.map((videoData, videoIdx) => renderVideoOrIframe(videoData, videoIdx)),
  ].filter(Boolean);

  return (
    <div
      className="intelligence-swiper new-intelligence-swiper"
      style={{ width: formatter(width), height: formatter(height) }}
    >
      {urlList?.length > 0 || videos?.length > 0 ? (
        <Carousel
          className="carousel-wrap"
          thumbWidth={110}
          showArrows={showArrows}
          showIndicators={showIndicators}
          infiniteLoop={infiniteLoop}
          autoPlay={autoPlay}
          emulateTouch={emulateTouch}
          showStatus={showStatus}
          stopOnHover={stopOnHover}
          showThumbs={showThumbs}
          useKeyboardArrows={useKeyboardArrows}
          swipeable={false} // 播放视频禁止自动切换
          dynamicHeight={dynamicHeight}
          selectedItem={activeSwiperIdx}
          renderThumbs={renderThumbs}
          onChange={handleSwiperChange}
        >
          {swiperContentList}
        </Carousel>
      ) : (
        <div className="nodata-center">{noDataTip}</div>
      )}
    </div>
  );
};
